import React, { useEffect, useState } from 'react';
import cn from 'classnames';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getPerformanceData } from '@Managers/Redux/AppState/AppState';

// MANAGERS

// CSS
import styles from './PhaserStatus.scss';
import FPSMetric from './PhaserStatus.fpsmetric';
import { qualityCheck } from './PhaserStatus.qualitycheck';

export const PhaserPerformance: React.FC<{}> = ({}) => {
    const performance = useAppSelector(getPerformanceData);
    const [performanceData, setData] = useState<Array<{ property: string; value: number | string }>>([]);

    useEffect(() => {
        setData(Object.entries(performance).map(([key, data], i) => ({ property: key, value: data })));
    }, [performance]);

    return (
        <div className={styles.performance_container}>
            <div className={styles.performance_data}>
                {performanceData.map((item: { property: string; value: number | string }, key: number) => (
                    <div className={styles.performance_item} key={key}>
                        <div className={styles.label}>{item.property}: </div>
                        <div className={styles.value}>
                            {item.value}
                            {(item.property === 'targetFps' || item.property === 'actualFps') && (
                                <span className={cn(styles.fpsMeter, styles[qualityCheck(item.value as number).className])}>
                                    {qualityCheck(item.value as number).text}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className={styles.performance_metric}>
                <FPSMetric />
            </div>
        </div>
    );
};
